import { useState } from 'react'
import { apiService, CommonServices, createCommonServices } from '../services'
import { FacadeData, FacadeServiceImpl, UserAgentString } from '../services/facade'
import { extendGnarEventsWith } from '../tracking/gnar'
import { isTouchDevice } from '../utils/is-touch'

export type AppInitResult = [CommonServices]

export const useAppInit = (requestData?: FacadeData, userAgent?: UserAgentString): AppInitResult => {
  const [commonServices] = useState(() => {
    return createCommonServices(apiService, () => new FacadeServiceImpl(requestData, userAgent))
  })

  if (IS_CLIENT_SIDE) {
    extendGnarEventsWith({
      deviceType: commonServices.browserService.deviceType,
      isMobile: commonServices.browserService.isMobileOrTablet,
      isTouchDevice: isTouchDevice(),
      os: commonServices.browserService.operatingSystem,
    })
  }

  return [commonServices]
}
